<template>
  <div>
    <div class="relative">
      <div
        v-if="!notificationModule?.length"
        class="flex flex-col items-center justify-center py-16"
      >
        <no-data
          title="Nothing to Display"
          :subTitle="`No templates found with the current filters`"
        />
      </div>
      <div v-else class="grid gap-3 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1">
        <NotificationCard
          :notifications="notificationModule"
          @edit="(val) => onTemplateEdit(val)"
          @delete="(val) => onTemplateDelete(val)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { convertToTitleCase } from '@/utils/common'
import NoData from '@/components/NoData.vue'
import NotificationCard from './NotificationCard.vue'
import {
  notificationTriggersOptions,
  getAllNotificationTriggers
} from '@/utils/workforce/constants'

export default {
  name: 'NotificationComponent',
  components: { NoData, NotificationCard },
  data() {
    return {
      templateTriggersList: notificationTriggersOptions,
      notificationModule: [],
      loading: false
    }
  },
  async mounted() {
    await this.fetchNotificationTemplates()
  },
  computed: {
    allTriggers() {
      return getAllNotificationTriggers()
    }
  },
  methods: {
    onTemplateEdit(i) {
      // Emit the actual template object, not just the index
      const template = this.notificationModule[i]
      this.$emit('edit-template', template)
    },
    titleCase(str) {
      return convertToTitleCase(str)
    },
    async fetchNotificationTemplates() {
      try {
        this.loading = true
        const response = await this.$axios.get('/orgSetup/notification-templates')
        this.notificationModule = (response.data?.templates || []).map((template) => ({
          ...template,
          showDummy: false
        }))
      } catch (error) {
        console.error('Error fetching templates:', error)
      } finally {
        this.loading = false
      }
    },
    async onTemplateDelete(index) {
      try {
        const template = this.notificationModule[index]
        await this.$axios.delete(`/whatsapp/templates/${template.templateName}`)
        await this.fetchNotificationTemplates()
        this.$toast.success('Template deleted successfully')
      } catch (error) {
        console.error('Error deleting template:', error)
        this.$toast.error('Failed to delete template')
      }
    }
  }
}
</script>
